import { UpdateResponsibleMedicalRecordDTO } from '../models/UpdateMedicalRecordDTO'
import { ResponsibleMedicalRecordRepository } from '../repositories/ResponsibleMedicalRecordRepository'

export function UpdateResponsibleMedicalRecordUseCase(
  repository: ResponsibleMedicalRecordRepository
) {
  return async (params: {
    id: string
    data: UpdateResponsibleMedicalRecordDTO
  }) => {
    return await repository.updateResponsibleMedicalRecord(params)
  }
}
